import { createFileRoute } from "@tanstack/react-router";
import ArticlesManager from "@/pages/admin/ArticlesManager";

export const Route = createFileRoute("/admin/articles/")({
  component: ArticlesManager,
});
